export default "__VITE_ASSET__CJeBqUvq__"